import {createContext, useState, useEffect, useContext} from "react";
import api from "../api/api.js";

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            api
                .get("/auth/me")
                .then((response) => setUser(response.data))
                .catch(() => {
                    setUser(null);
                    localStorage.removeItem("token");
                }).finally(() => {
                setIsLoading(false)
            });
        } else {
            setIsLoading(false)
        }
    }, []);

    const login = async (email, password) => {
        const response = await api.post("/auth/login", {
            email,
            password,
        });
        const token = response.data.token;

        if (token) {
            console.log("Login successful");
            localStorage.setItem("token", token);
            setUser(response.data.user);
        } else {
            console.log("Ошибка: токен не получен");
        }
    };

    const logout = () => {
        localStorage.removeItem("token");
        setUser(null);
    }

    const register = async ({name, email, password, telegram}) => {
        await api.post("/auth/signup", {
            email,
            password,
            telegram,
            name
        });

    }

    return (
        <AuthContext.Provider value={{user, isLoading, login, logout, register}}>
            {children}
        </AuthContext.Provider>
    );
};